import {FirstCategoryContext} from '@helpers/websites/FirstCategoryContext'
import {Fragment} from 'react'
import BrandBar from '../../BrandBar'
import Category from '../../Category'
import Loading from '../../Loading'
import NoBrandDivider from '../../NoBrandDivider'

export default function Categories({
  productsContentProps,
  sorting,
  setOpen,
  setSelect,
  categoriesRefs,
}) {
  const {categories, productsLayout, layout, menuId, hidePrice, productCardDesign, website} =
    productsContentProps

  if (!categories) return <Loading />

  const visibleCategories = !categories
    ? []
    : categories.items.filter(category => category.products.length)
  let lastBrandId = null
  const isMultiBrand = website.isMultiBrand

  return visibleCategories.map((category, index) => {
    let brand = null
    if (category.brand && category.brand._id !== lastBrandId) {
      brand = category.brand
      lastBrandId = brand._id
    }

    const dividerContent =
      !category.brand && lastBrandId ? <NoBrandDivider key={lastBrandId} /> : null
    const brandContent = brand ? <BrandBar brand={brand} key={brand._id} /> : null

    if (!category.brand && lastBrandId) {
      lastBrandId = null
    }

    return (
      <Fragment key={category._id}>
        {isMultiBrand && (
          <>
            {brandContent}
            {dividerContent}
          </>
        )}
        <div
          ref={ref => {
            if (ref) {
              categoriesRefs[category._id] = ref
            }
          }}
        >
          <FirstCategoryContext.Provider value={index === 0}>
            <Category
              productsLayout={productsLayout}
              layout={layout}
              productCardDesign={productCardDesign}
              category={category}
              menuId={menuId}
              hidePrice={hidePrice}
              select={select => {
                setSelect(select)
                setOpen(true)
              }}
              sorting={sorting}
              hideNotAvailableProducts={website.hideNotAvailableProducts}
            />
          </FirstCategoryContext.Provider>
        </div>
      </Fragment>
    )
  })
}
